<template>
  <div @click="linkTo" v-if="disabled && printMode" class='showText' :class="{'link': valueType}" v-html="value"></div>
  <el-input v-model="value2" v-else v-bind="{
    type, disabled, maxlength, minlength, showWordLimit, placeholder, clearable,
    size, prefixIcon, suffixIcon, rows, autosize, readonly, max, min, step
    }" @blur="$emit('blur', $event)"
     @focus="$emit('focus', $event)"
     @change="$emit('change', $event)"
     @input="$emit('input', $event)"
     @clear="$emit('clear', $event)">
      <template slot="append">
        <slot name="append"></slot>
      </template>
    </el-input>
</template>
<script>
export default {
  name:'l-input',
  props: {
      value:{
        type:[String,Number],
        default:''
      },
      type: {
        type:String,
        default:'text'
      },
      size: {
        type:String,
        default:'' // medium / small / mini
      },
      prefixIcon: {
        type:String,
        default:'' // medium / small / mini
      },
      suffixIcon: {
        type:String,
        default:'' // medium / small / mini
      },
      maxlength: Number,
      minlength: Number,
      rows: {
        type:Number,
        default:2
      },
      'showWordLimit': {
        type:Boolean,
        default:false
      },
      readonly: {
        type:Boolean,
        default:false
      },
      placeholder: String,
      border:Boolean,
      clearable:Boolean,
      disabled:Boolean,
      autosize: {
        type: Boolean|Object,
        default: false
      },
      max: {
        default: ''
      },
      min: {
        default: ''
      },
      step: {
        default: ''
      },
      printMode: {
        default: false
      },
      valueType: {
        default: '' // email link
      }
      
  },
  data () {
    return {
    };
  },
  mounted () {
  },
  computed:{
    value2:{
      get(){
        return this.value
      },
      set(val){
        this.$emit('input', val)
        this.$emit('change', val)
      }
    }
  },
  methods:{
    linkTo () {
      if (this.value && this.valueType) {
        switch (this.valueType) {
          case 'link':
            window.open(this.value)
            break;
          case 'email':
            window.open(`mailto:${this.value}`)
            break;
          default:
            this.$emit('click')
            break;
        }
      }
    }
  }
}
</script>
<style lang="less">
  @import './index.less';
</style>
